import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { dirtyOrTouchedErrorStateMatcher } from '../../constants/dirty-or-touched-error-state-matcher';
import { validationMessages } from '../../messages';

@Component({
  selector: 'app-ui-text-area',
  templateUrl: './ui-text-area.component.html',
  styleUrls: ['./ui-text-area.component.scss'],
  standalone: false,
})
export class UiTextAreaComponent {
  @Input() label = '';
  @Input() description = '';
  @Input() control: UntypedFormControl;
  @Input() required = false;
  @Input() placeholder = '';
  @Input() messages = validationMessages;
  @ViewChild('textarea') textarea: ElementRef;

  readonly errorStateMatcher = dirtyOrTouchedErrorStateMatcher;
}
